<div class="card feedback-card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="mb-0">
      {{ "Listing" | translate }}:
      <a [routerLink]="['/equipment/marketplace/listing', feedback.listingHash]">{{ feedback.listingDisplayName }} </a>

      <br />

      {{ "From" | translate }}: {{ feedback.userDisplayName }}
    </h5>

    <div class="updated">
      {{ feedback.updated | localDate | timeago }}
    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div *ngIf="feedback.communicationValue" class="col feedback-value">
        <fa-icon [icon]="equipmentMarketplaceService.iconizeFeedbackValue(feedback.communicationValue)"></fa-icon>
        <span>{{ "Communication" }}</span>
      </div>

      <div *ngIf="feedback.speedValue" class="col feedback-value">
        <fa-icon [icon]="equipmentMarketplaceService.iconizeFeedbackValue(feedback.speedValue)"></fa-icon>
        <span>
          <ng-container *ngIf="feedback.targetType === TargetType.SELLER">
            {{ "Speed of delivery" }}
          </ng-container>
          <ng-container *ngIf="feedback.targetType === TargetType.BUYER">
            {{ "Speed of payment" }}
          </ng-container>
        </span>
      </div>

      <div *ngIf="feedback.accuracyValue" class="col feedback-value">
        <fa-icon [icon]="equipmentMarketplaceService.iconizeFeedbackValue(feedback.accuracyValue)"></fa-icon>
        <span>{{ "Accuracy of item descriptions" }}</span>
      </div>

      <div *ngIf="feedback.packagingValue" class="col feedback-value">
        <fa-icon [icon]="equipmentMarketplaceService.iconizeFeedbackValue(feedback.packagingValue)"></fa-icon>
        <span>{{ "Packaging quality" }}</span>
      </div>
    </div>

    <p *ngIf="feedback.message" [innerHTML]="feedback.message | safeNl2br" class="message"></p>
  </div>

  <div *ngIf="currentUserWrapper$ | async as currentUserWrapper" class="card-footer">
    <button
      *ngIf="recipient && listing && currentUserWrapper.user.id === feedback.user"
      (click)="openFeedbackModal($event)"
      class="btn btn-secondary"
    >
      {{ "Edit" }}
    </button>

    <button (click)="openCommentsModal($event)" class="btn btn-secondary">
      {{ "Comments" | translate }}
      <span class="badge rounded-pill bg-dark">
        <astrobin-nested-comments-count
          [contentType]="contentType"
          [objectId]="feedback.id"
        ></astrobin-nested-comments-count>
      </span>
    </button>
  </div>
</div>
